import Bus from './bus'
// import ModalsDeck from './ModalsDeck.vue'
import ModalsKeep from './ModalsKeep.vue'

const defaults = {

}

const Plugin = {
  install (Vue, options = {}) {
    options = Object.assign(defaults, options)

    Vue.component('ModalsKeep', ModalsKeep)

    // Global $fwmodal property
    Vue.prototype.$fwModals = new Vue({
      name: '$fwModals',

      created () {
        Bus.$on('opened', data => { this.$emit('fwmodals:opened', data) })

        Bus.$on('closed', data => { this.$emit('fwmodals:closed', data) })

        Bus.$on('destroyed', data => { this.$emit('fwmodals:destroyed', data) })

        this.$on('new', options => { this.open(options) })

        this.$on('close', data => { this.close(data) })
      },

      methods: {
        open (options = null) {
          Bus.$emit('new', options)
        },

        close (data = null) {
          Bus.$emit('close', data)
        }
      }
    })
  }
}

export default Plugin

export {
  Bus,
  ModalsKeep
}
